import { IDefineCommand, ICommand, IQuery } from 'core-ts-types';
import { ORM } from 'utility-ts-orm';
import * as _4 from 'lodash4';

angular.module('capability-ng-scheduler').factory(
  'getRegistrationCheckCommand',
  ($http: ng.IHttpService, defineCommand: IDefineCommand, log: any): ICommand =>
    defineCommand('getRegistrationCheckCommand', (deferred: ng.IDeferred<IQuery[]>, termId: number) => {
      $http
        .get(`reg/precheck/term/${termId}/`)
        .then((resp: ng.IHttpPromiseCallbackArg<any>) => {
          return deferred.resolve(resp.data);
        })
        .catch((e) => {
          log.issue('Unable to get pre registration check');
          return deferred.reject(e);
        });
    })
);



// WEBPACK FOOTER //
// ./app/vendor/capability-ng-scheduler/src/views/registration/commands/get_registration_check_command.ts